import Swal from "sweetalert2";

const SwalLoad = () => {
    Swal.fire({
        icon: "info",
        html: "Loading... Please Wait",
        willOpen: () => {
            Swal.showLoading();
        },
        showConfirmButton: false,
        allowOutsideClick: false,
    });
};
const SwalInfo = (text) => {
    Swal.fire({
        icon: "info",
        html: text,
        customClass: {
            confirmButton: "btn btn-success",
        },
        // buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: "ตกลง",
    });
};
const SwalErr = (text) => {
    Swal.fire({
        icon: "error",
        html: text,
        customClass: {
            confirmButton: "btn btn-success",
        },
        // buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: "ตกลง",
    });
};
const SwalSuccess = async (text) => {
    var res = await Swal.fire({
        icon: "success",
        html: text,
        customClass: {
            confirmButton: "btn btn-success",
        },
        // buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: "ตกลง",
    });

    return res;
};

const SwalConfirm = async ({ title = "", description = "", html = "", icon = "warning", confirm = "ยืนยัน", cancel = "ยกเลิก", width = 500 }) => {
    var result = await Swal.fire({
        title: title,
        text: description,
        width: width,
        html: html,
        icon: icon,
        customClass: {
            confirmButton: "btn btn-success ml-2",
            cancelButton: "btn btn-danger",
        },
        // buttonsStyling: false,
        confirmButtonText: confirm,
        cancelButtonText: cancel,
        reverseButtons: true,
        showCancelButton: true,
    });

    return result;
};

const SwalConfirmDontAsync = (text) => {
    var result = Swal.fire({
        title: text,
        icon: "warning",
        customClass: {
            confirmButton: "btn btn-success ml-2",
            cancelButton: "btn btn-danger",
        },
        // buttonsStyling: false,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        reverseButtons: true,
        showCancelButton: true,
    });

    return result;
};

const SwalClose = () => {
    Swal.close();
};

const CSwl = {
    SwalLoad: SwalLoad,
    SwalErr: SwalErr,
    SwalClose: SwalClose,
    SwalSuccess: SwalSuccess,
    SwalConfirm: SwalConfirm,
    SwalConfirmDontAsync: SwalConfirmDontAsync,
    SwalInfo: SwalInfo
};

export default CSwl;
